import React from "react";
import img from "../assets/web development.png";
import img2 from "../assets/creative design.png";
import img3 from "../assets/responsive design.png";
import img4 from "../assets/retouch.png";
import img5 from "../assets/support.png";
import img6 from "../assets/web ideas.png";

function Services() {
  const services = [
    {
      img: img,
      title: "Web Development",
      desc: "I can build a website by using HTML, CSS, JavaScript, react/next JS , Tailwind CSS ",
    },
    {
      img: img3,
      title: "Responsive Design",
      desc: " Your website will be 100% responsive for all devices: Tablets and Smart phones.",
    },
    {
      img: img2,
      title: "Creative Design ",
      desc: "I can edit your current website by adding a new content to make it much better.",
    },
    {
      img: img6,
      title: "Web Ideas",
      desc: "I could turn your ideas into a real projects with high quality.",
    },

    {
      img: img4,
      title: "Retouch",
      desc: "I can help you by redesign your current webiste to looks much better",
    },

    {
      img: img5,
      title: "Support",
      desc: "Support is available if you wanna make any changes for your website after dilvering it.",
    },
  ];
  return (
    <div>
      <section id="services">
        <div className="top_section">
          <h5>What I Offer</h5>
          <h2>My Services</h2>
        </div>
        <div className="container services">
          {services.map((i) => (
            <div className="service">
              <img src={i.img} alt="" srcset="" />

              <h4>{i.title}</h4>
              <h5>{i.desc}</h5>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Services;
